export default {
	logoName:'CONTRACTS',
	comboChooseText:'--Таңдау--',
	save :"Сақтау",
	reset:"Қалпына келтіру",
	logOut:'Жүйеден шығу',
	
	system:{
		errorTitle:'Қате',
		warningTitle:'Назар аударыңыз',
		successTitle:'Жетістік',
		successMsg:"Сәтті аяқталды",
		dublicationMsg:'Жазба қайталанған !!!',
		newRecord:"Жаңа жазба",
		confirmMsg:'Сіз сенімдісіз бе ?',
		selectAll:'Барлығын таңдаңыз',
		unSelectAll:'Барлығын алып тастау',
		status:'Статус',
		beginDate:"Басталу күні",
		endDate:"Аяқталу күні",
		search:"Іздеу",
		loading:"Жүктелуде",
		add:'қосу',
		delete:'жою',
		update:'жаңарту',
		failMsg:"Белгісіз қате анықталды. Қайталап көріңіз.",
		delete:"Жою",
		update:"Жаңарту",
		actions:"Әрекеттер"
	},

	mainMenu: {
		currentLang:'KAZ',
		projects:'келісім-шарттар',

		project:{
			add:"жоба қосу",
			list:"барлық жобалар"
		},
		settings: 'анықтамалық деректер',
		setting:{
			companies:"компаниялар",
			users:"пайдаланушылар",

			
			cats:"санаттар",
			departments:"бөлімдер",
			locations:"",
			level:"жоба деңгейлері",
			budgets:"бюджеттер",
			status:"күй түрлері",
			types:"жоба түрлері",
			roles:"рөлдер"
		},
		graphs :'Графикалық ақпарат',
	},

	//begining of Dag
	pForm:{
		createNew: "Жаңа жоба құру",
		pKm: "Километр",
		pPrice: "Келісім-шарт құны, тенге",
		pAddress: "Мекен-жайы",
		organizations: "Мердігерлік ұйым",
		pNumber: "Келісім-шарт номері",
		pName: "Жоба атауы",
		pDate: "Жобаны құру күні",
		endDate: "Жобаның аяқталатын күні",
		pTopCover: "(Ж,Ж,Қ. км) жабынның жоғарғы қабаты",
		pBottomCover: "(Ж.Т.Қ. км) жабынның төменгі қабаты",
		pMainCover: "тегістеу қабаты / негізі",
	},
	//end of Dag
	prject: {
		levelName: "Жоба түрі",
		locationName: "Обласы",
		pNumber: "Келісім-шарт номері",
		pPrice: "Келісім-шарт құны, тенге",
		pKm: "Километр",
		pDate: "Келісім-шарт құру күні",
		pAddress: "Адрес",
		ortNames: "Мердігерлік ұйым",
		bActions: "Есеп",
		Actions: "Әрекеттер",
	},


	lMenu:{
		courses:"курстар",
		freeCourses:"тегін курстар",
		start:"бастау"
	},
	lms:{
		machineTurnOnError:"an error occured when turning on machines"
	},
	
	deliveryList:{
		deliveryListTitle:"Тапсырыстар тізімі",
		newDelivery: "Жаңа",
		inProgress:"Орындалуда",
		done:"Дайын",
		deepSearch:"Терең іздеу",
		cassReport:"Касс есебі",
		byOrderNumber:"Тапсырыс нөмірі бойынша",
		byNewOrder:"Жаңа тапсырыс бойынша",
		

	},
	orderDate:"Тапсырыс күні",
	orderNumber:"Тапсырыс нөмірі",
	userInfo:"Клиент туралы ақпарат",
	totalProductPrice:"Өнімнің жалпы бағасы",
	takenCostByCash:"Қолма-қол ақшамен",
	takenCostByCard:"Карта арқылы",
	deliveryLoan:"Тапсырыс несиесі",
	showDetails:"Мәліметтерді көрсету",
	updateOrder:"Тапсырысты жаңарту",
	deleteOrder:"Тапсырысты жою",
	noSlicers:"Кесушiлер тандамаган",
	catName:"Өнім санаты",
	colorName:"Өнімнің түсі",
	measureName:"Өлшемі",
	productCount:"Өнім саны",
	doneCount:"Аяқталған саны",
	leftCount:"Аяқталмаған саны",
	productPrice:'Өнімнің бағасы',
	totalPrice:"Жалпы бағасы",
	wareHouseName:"Қойма",
	
	listSlicers:"Кесушілер",
	completed:"Аяқталды",
	unCompleted:"Аяқталмаған",
	orderActions:"Әрекеттер",
	teacherModule:{
		myDocuments : 'Менің құжаттарым',
		newDocument : 'Жаңа құжатты толтыру'
	},
	userPage :{
		userList:'Қолданушылар тізімі'
	},
	wrongFile:"Жүктелуі тиіс файлдың атын ауыстыруыңызды сұраймыз. Файл атауында нүкте немесе с.с. арнайы символдар болмауы тиіс!!!",
	
	lms:{
		login:"Жүйеге кіру",
		register:"Жүйеге тіркелу",
		userList:{
			systemUsers:'Жүйе пайдаланушылары',
			firstName:'Аты',
			lastName:'Тек',
			userName:'Логин аты',
			phoneNumber:'Телефон нөмірі',
			role :'Жүйедегі рөлі',
			blocking:"Блоктау",
			unblocking:"Блоктан шығару",
			enroll:"Тіркелу"
		},
		
		userForm:{
			modalTitle:"Пайдаланушы ақпараты",
			userType:"Пайдаланушы түрі",
			thirdName:"Әкесінің аты",
			lastName:"Тек",
			firstName:"Аты",
			phoneNumber:"Телефон нөмірі",
			email:"Электрондық пошта",
			password:"Құпия сөз",
			repeatPassword:"Құпия сөзді қайталаңыз",
			addUser:"Пайдаланушы қосу",
			clear:"Тазалау",
			roleConfirm:"Пайдаланушы түрін таңдау керек",
			passwordsNotMatchError:"Сіз енгізген құпия сөздер бірдей емес!!!",
			dublicatedEmail:"Электрондық пошта бұрыннан тіркелген!!!",
			wrongLogin:"Электрондық пошта немесе құпия сөз дұрыс емес.",
			blockedUser:"Сіз блокталған пайдаланушысыз. Жүйе әкімшісіне хабарласыңыз"
		},
		
		
		courseList:{
			mainTitle:"Курс пен модульді басқару",
			courseList:"Курс тізімі",
			courseName:"Аты",
			moduleCount:"Модульдер",
			courseCount:"Курстар",
			studentCount:"Студенттер",
			status:"Күй",
			delete:"Жою",
			active:"Белсенді",
			inActive:"Белсенді емес",
			newCourse:"Жаңа курс [+]",
			moduleName:"Модуль",
			lectureCount:"Лекция",
			labCount:"Лабротория",

			//new things
			yes:"Иә",
			no:"Жоқ",
			isFree:"Курс тегін бе, жоқ па",
			description:"Сипаттама",
			delete:"жою",
			introduction:"Курсқа кіріспе",
			isDefault:"Негізгі,негізгі емес",
			buildIntro:"Курстың кіріспесін құрастыру"

			
		},
		courseForm:{
			chooseFile:"Файлды таңдаңыз ...",
			dropFile:"Файлды осы жерге тастаңыз..."
		},

		moduleList:{
			moduleFiles:"Модуль бөліктері",
			create:"Модуль бөліктерін құрастыру",
			createModule:"Модуль жасау"
		},
		moduleForm:{
			modalTitle:"Курсты құру және жаңарту",
			chooseCourses:"Модульді қамтитын курстарды таңдаңыз"
		},
		serverList:{
			mainTitle:"Лабротория құруға арналған серверлер",
			serverName:"Сервер атауы",
			ipAddress:"Сервер IP",
			description:"Сипаттама",
			imagePath:"Логотип",
			createServer:"Сервер құру",
			userName:"Сервер пайдаланушы аты",
			password:"Сервер құпия сөзі",
			protocol:"Сервер протоколы",
			hasPublicIp:"Серверде сыртқы IP бар ма ?",
			ami:"AMI",
			ipMask:"IPMASK",
			instanceType:"Instance type"
		},
		labList:{
			mainTitle:"Әр модуль үшін лаброториялар",
			chooseServers:"Лабротория үшін пайдаланылатын серверлерді таңдаңыз",
			labName:"Лабротория атауы",
			labText:"Лабротория сипаттама",
			labEmbedded:"Лабротория бейне сабақ",
			chooseScorm:"Лаброторияға арналған SCORM файлы",
			labFiles:"Қосылған бөліктер",
			createLab:"Лабротория құру",
			servers:"Серверлер",

			isLecture:"Лекция ма, жоқ па?",
			lectureList:"Лекциялар",
			createLecture:"Дәріс құру",
			lectureName:"Лекция атауы",
			lectureText:"Лекция сипаттама",
			addToModule:"Модульге қосу"

		},
		videoList:{
			mainTitle:"Бейне тізімі",
			name:"Аты",
			description:"Сипаттама",
			showVideo:"Көру",
			videoPath:"Бейне коды",
			bottomText:"Бейнероликтің кіріспе мәтіні",
			createVideo:"Жаңа бейне жасау"
		},
		catList:{
			createCat:"Санат жасау",
			catName : "Санат атауы"
		},
		add:"Жазба қосу",
		clear:"Тазалау",
		chooseImage:"Суретті таңдаңыз.",
		detailSuccess:"Компонент сәтті жасалды.",
		image:"Фото компонент",
		scorm:"Scorm компоненті",
		video:"Бейне компоненті",
		text:"Мәтіндік компонент",
		command:"Code, command",
		detailComps:"Құрамдас бөліктер",
		courseCategory:"Курс санаты [+]",
		chooseCats:"Санаттарды таңдаңыз",
		isDefault:"Лекция негізгі бола ма?",
		vps:{
			manageVps:"VPS басқару",
			vpsName:"VPS атауы",
			manageVps:"Server vpses",
			chooseVpses:"VPS таңдаңыз"
		},
		myCourses:"Менің курстарым",
		mustLoginError:"Курсты көру үшін жүйеге кіру керек!!!",
		selectCourses:"Курстарды таңдау."

	},
	regForm:{
		wrongLogin:"Электрондық пошта немесе құпия сөз дұрыс емес.",
		emailNotVerified:"Email расталмаған. Тіркелуді аяқтау үшін хаттағы кодты енгізіңіз.",
		emailAlreadyRegistered:"Бұл email тіркелген. Құпия сөзді ұмытсаңыз — құпия сөзді қалпына келтіруді пайдаланыңыз.",
	}
};